import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as occupancyTypesApi from '@/features/occupancy-types/occupancy-types.api';

interface OccupancyTypePickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const OccupancyTypePicker = ({
  label = 'Occupancy type',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: OccupancyTypePickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.occupancyTypes',
      fetch: async (search) => {
        const res = await occupancyTypesApi.listOccupancyTypes({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await occupancyTypesApi.getOccupancyType(id);
        } catch {
          return null;
        }
      },
      toOption: (o) => ({
        value: o.id,
        label: o.name,
        description: `${o.paxCount} pax`,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select an occupancy type"
      searchPlaceholder="Search occupancy types..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
